import { Link ,useLocation } from "react-router-dom"
import "./LeftNavBar.scss"
import { useAdminData } from "../DataContext/DataContext"
import React, { useMemo } from "react"

function Navigation({ isCollapsed }) {
    const { pathname } = useLocation();  


  const {blogs,messages} =useAdminData()

   const blogsLength = useMemo(() => blogs?.filter(post=>post.pending).length,[blogs])
    const unreadMessages = useMemo(() => messages?.filter(msg=>!msg.read).length,[messages])

  const navItems = [
    { label: "Overview", icon: <i  className="ri-dashboard-line text-xl"></i>, to: "/", badge: null },
    { label: "Posts", icon: <i className="ri-article-line text-xl"></i>, to: "/admin/posts", badge: blogsLength },
    { label: "Messages", icon: <i className="ri-mail-line text-xl"></i>, to: "/admin/messages", badge: unreadMessages },
    { label: "Settings", icon: <i className="ri-settings-line text-xl"></i>, to: "/admin/settings", badge: null },
  ]

  return (
    <nav className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <h1>AFRIYOFA</h1>
      </div>  
      <ul className="nav-items">
        {navItems?.map((item,i) => {
            const isActive = pathname === item.to
        

         return <li key={item.label} style={{listStyle:"none"}}>
            <Link to={item.to} className={`nav-item ${isActive ? "active" : ""}`}>
              {item.icon && <span className="nav-icon">{item.icon}</span>}
              <span className="nav-label">{item.label}</span>
              {item.badge >0 && <span className="nav-badge">{item.badge}</span>}
            </Link>
          </li>
})}
      </ul>
    </nav>
  )
}

export default React.memo(Navigation)